export class PaginationMeta {
  constructor(props) {
    this.total = props?.total || 0;
    this.limit = props?.limit || 10;
    this.skip = props?.skip || 0;
    this.hasNext = props?.hasNext || false;
  }
}
